import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb/CourseBreadcrumbs";
import CourseDetailsMain from "./CourseDetailsMain";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";

const CourseDetails = () => {
  const location = useLocation(); // Get the location object
  const { course ,name} = location.state || {};

console.log(name)

  return (
    <body className="course-single">
      <Header parentMenu="course" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb
            courseBannerImg={course?.cover}
            type={`${course?.levels}`}
            courseTitle={course?.name}
            courseName={course?.name}
            courseAuthor={course?.instructor}
            courseLesson={course?.lectures}
            courseEnrolled={course?.students}
          />

          <CourseDetailsMain
            courseID={course?._id}
            courseImg={`https://back.yourfrenchteachers.com/${course?.thumbnail}`}
            courseTitle={course?.name}
            courseName={course?.name}
            courseAuthor={course?.instructor}
            courseLesson={course?.lectures}
            courseDuration={course?.duration}
            courseEnrolled={course?.maxStudents}
            courseDescription={course?.description}
            courseRegularPrice={course?.price.replace(' MMK', '')}
            course={course?.price}
            count={course?.lectureCount}
            name={name}
            courseLanguage={course?.language}
            discount={course?.off?.replace('%', '')}
            enrolled={course?.maxStudents}
            start={course?.start_course}
            levels={course?.levels}
            ages={course?.ages}
           relatedcourse={course}
           video={course?.video}
           lectures={course?.lectures}
          />
            <DownloadApp />

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </body>
  );
};

export default CourseDetails;
